import request from '@/utils/request'

export function getAll() {
  return request({
    url: '/base/salesOrganization/getAll',
    method: 'get'
  })
}

export function getPage(condition, pagination) {
  return request({
    url: '/base/salesOrganization/page',
    method: 'post',
    data: { condition: condition, pagination: pagination }
  })
}

export function saveOrUpdate(data) {
  return request({
    url: '/base/salesOrganization/saveOrUpdate',
    method: 'post',
    data
  })
}

export function get(id) {
  return request({
    url: '/base/salesOrganization/get',
    method: 'get',
    params: { id }
  })
}

export function deleteById(id) {
  return request({
    url: '/base/salesOrganization/deleteById',
    method: 'post',
    data: { id: id }
  })
}

export function deleteBatchByIds(ids) {
  return request({
    url: '/base/salesOrganization/deleteBatchById',
    method: 'post',
    data: { ids: ids }
  })
}

export function exportExcel(condition, pagination) {
  return request({
    url: '/base/salesOrganization/exportExcel',
    method: 'post',
    data: { condition: condition, pagination: pagination },
    responseType: 'blob'
  })
}

